(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", init);
  if (document.readyState !== "loading") init();

  function init() {
    document.querySelectorAll(".ph-collection").forEach(setupSection);
  }

  function setupSection(section) {
    if (section.dataset.phInit) return;
    section.dataset.phInit = "true";

    const grid = section.querySelector("[data-grid]");
    const cards = Array.from(section.querySelectorAll("[data-product-card]"));
    const filterBtns = section.querySelectorAll(".ph-filter-btn");
    const sortSelect = section.querySelector("[data-sort-select]");

    // ---- Filtering ----
    filterBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        filterBtns.forEach((b) => {
          b.classList.remove("is-active");
          b.setAttribute("aria-selected", "false");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-selected", "true");
        const filter = btn.dataset.filter;

        cards.forEach((card) => {
          const tags = (card.dataset.productTags || "").split(",");
          const show = filter === "all" || tags.includes(filter);
          card.hidden = !show;
        });
      });
    });

    // ---- Sorting ----
    if (sortSelect) {
      sortSelect.addEventListener("change", () => {
        const val = sortSelect.value;
        const sorted = [...cards];

        if (val === "price-asc") {
          sorted.sort((a, b) => parseFloat(a.dataset.productPrice) - parseFloat(b.dataset.productPrice));
        } else if (val === "price-desc") {
          sorted.sort((a, b) => parseFloat(b.dataset.productPrice) - parseFloat(a.dataset.productPrice));
        } else if (val === "title-asc") {
          sorted.sort((a, b) => a.dataset.productTitle.localeCompare(b.dataset.productTitle));
        } else if (val === "best-selling") {
          sorted.sort((a, b) => parseFloat(b.dataset.bestSelling || 0) - parseFloat(a.dataset.bestSelling || 0));
        }
        // "manual" -> leave as-is (original DOM order)

        if (val === "manual") {
          cards.forEach((c) => grid.appendChild(c));
        } else {
          sorted.forEach((c) => grid.appendChild(c));
        }
      });
    }

    // ---- Variant selection ----
    cards.forEach(setupVariantPicker);

    // ---- Add to cart (AJAX) ----
    cards.forEach(setupAddToCart);
  }

  function setupVariantPicker(card) {
    const swatchGroups = card.querySelectorAll(".ph-variant-swatches");
    if (!swatchGroups.length) return;

    swatchGroups.forEach((group) => {
      group.addEventListener("click", (e) => {
        const btn = e.target.closest(".ph-swatch");
        if (!btn) return;
        group.querySelectorAll(".ph-swatch").forEach((s) => s.classList.remove("is-selected"));
        btn.classList.add("is-selected");
        // NOTE: for full variant-price/availability sync, wire this to product.js JSON
        // (fetch `${productUrl}.js`) and map selected option values to a variant ID.
        // Left as a light hook point since option/variant structures vary per product.
      });
    });
  }

  function setupAddToCart(card) {
    const form = card.querySelector("[data-product-form]");
    if (!form) return;

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const button = form.querySelector("[data-atc-button]");
      const addedMsg = card.querySelector("[data-added-msg]");
      if (button.disabled) return;

      form.classList.add("is-loading");
      button.disabled = true;

      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          form.classList.remove("is-loading");
          button.disabled = false;

          if (data.status && data.status >= 400) {
            console.error("Pethaze add-to-cart error:", data.description || data.message);
            button.querySelector(".ph-btn__label").textContent = "Try Again";
            setTimeout(() => {
              button.querySelector(".ph-btn__label").textContent = "Add to Cart";
            }, 2000);
            return;
          }

          if (addedMsg) {
            addedMsg.classList.add("is-visible");
            setTimeout(() => addedMsg.classList.remove("is-visible"), 2200);
          }

          // Update cart count bubble if theme exposes one
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
          refreshCartCount();
        })
        .catch((err) => {
          console.error("Pethaze add-to-cart request failed:", err);
          form.classList.remove("is-loading");
          button.disabled = false;
        });
    });
  }

  function refreshCartCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        document.querySelectorAll("[data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }
})();
